import React from "react";

import LinkRedirect from "../../../../components/common/LinkRedirect";
import { ButtonOutlined } from "../../../../components/common/Buttons/Button.Style";

import * as S from "./EthicsChannelSection.style";

export const EthicsChannelSection = () => {
  return (
    <S.EthicsChannelSectionContainer>
      <S.EthicsChannelSectionContent className="container">
        <S.EthicsChannelSectionHeader>
          <S.EthicsChannelSectionTitle>
            Canal de ética
          </S.EthicsChannelSectionTitle>

          <S.EthicsChannelSectionDescription>
            Se você suspeita ou presenciou alguma prática antiética ou ilegal
            relacionada aos nossos negócios, fique à vontade para relatar o
            ocorrido no nosso canal de ética que é operado pelo parceiro Contato
            Seguro. Todas as denúncias serão tratadas de forma sigilosa e
            confidencial. Se preferir, você pode registar o seu relato de forma
            anônima.{" "}
            <strong>Para fazer o seu relato, clique no botão abaixo</strong>.
          </S.EthicsChannelSectionDescription>
        </S.EthicsChannelSectionHeader>

        <LinkRedirect
          as={ButtonOutlined}
          type="button"
          href="https://www.contatoseguro.com.br/cnpholdingbrasil"
          description={
            <>
              <p>
                Os relatos são tratados com sigilo e, mesmo que você se
                identifique, garantimos que sua identidade e a própria
                investigação não serão reveladas. Entendemos que, ao registrar
                um relato, você colabora com a nossa ética e conformidade, por
                isso, não admitimos qualquer tipo de retaliação.
                <br />
                <br />
                Aviso Legal sobre Proteção de Dados Pessoais Este canal de
                denúncias é operado pela empresa Contato Seguro e gerenciado
                pela CNP Seguros Holding Brasil, como parte de nossos esforços
                contínuos para garantir a integridade, ética e conformidade em
                nossas operações. Entendemos a importância da proteção dos seus
                dados pessoais e estamos comprometidos em garantir a segurança e
                privacidade das informações fornecidas através deste Canal. Ao
                enviar uma denúncia, você poderá fornecer informações pessoais
                (seu nome, endereço de e-mail), documentos e detalhes
                relacionados à denúncia, que serão tratadas de forma
                confidencial, segura, e serão acessadas por pessoas autorizadas
                envolvidas na investigação, inclusive atuantes fora da
                jurisdição brasileira. Seus dados poderão ser compartilhados
                quando exigido por lei ou quando necessário para investigações
                internas ou processos judiciais. Manteremos as informações
                armazenadas apenas pelo tempo necessário para conclusão do
                processo de investigação ou da ação judicial, o que encerrar por
                último. Ao usar este canal, você concorda com os termos e
                condições estabelecidos neste aviso legal. Reservamo-nos o
                direito de atualizar ou modificar este aviso a qualquer momento.
                Para informações adicionais acesse nossa Política de
                Privacidade.
              </p>
            </>
          }
        >
          Registrar relato
        </LinkRedirect>
      </S.EthicsChannelSectionContent>
    </S.EthicsChannelSectionContainer>
  );
};
